document.addEventListener('DOMContentLoaded', function() {
  const quoteButton = document.querySelector('[data-quote-trigger="true"]');
  
  if (quoteButton) {
    const addToCartForm = document.querySelector('form[action*="/cart/add"]');
    
    if (addToCartForm) {
      addToCartForm.style.display = 'none';
      quoteButton.addEventListener('click', function() {
        console.log('Quote request triggered');
      });
    }
  }
});